import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import DateInput from './input';
import Tooltip from 'components/tooltip';

export default function ApexDateFormGroup({
  className,
  disabled,
  disabledMessage,
  hasError,
  inputClassName,
  label,
  name,
  required,
  ...props
}) {
  const groupClassName = classNames('form-group', className, {
    'has-error': hasError,
    required: required,
  });

  let formGroup = (
    <div className={groupClassName}>
      <label className="control-label">
        {label}
        {required ? <abbr title="required">*</abbr> : null}
      </label>
      <div className="form-input-container">
        <DateInput
          className={classNames('form-control', inputClassName)}
          disabled={disabled}
          name={name}
          {...props}
        />
      </div>
    </div>
  );

  if (disabled && disabledMessage) {
    formGroup = <Tooltip content={disabledMessage}>{formGroup}</Tooltip>;
  }

  return formGroup;
}

ApexDateFormGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  hasError: PropTypes.bool,
  inputClassName: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string
};
